import { Box, Image, Text, Title } from "@mantine/core";
import Markdown from "markdown-to-jsx";
import Link from "next/link";
import katex from "katex";
import "katex/dist/katex.min.css";

const BoxWrapper = (props) => {
    const { children } = props;
    // console.log("props: ", props);
    return (
        <Box {...props} sx={{ wordBreak: "break-word" }}>
            {children}
        </Box>
    );
};

export const InlineMath = ({ children }) => {
    const markup = katex.renderToString(children, { throwOnError: false });
    return <span dangerouslySetInnerHTML={{ __html: markup }} />;
};

export const BlockMath = ({ children }) => {
    const markup = katex.renderToString(children, {
        displayMode: true,
        throwOnError: false,
    });
    return <div dangerouslySetInnerHTML={{ __html: markup }} />;
};

const MyImg = (props) => {
    return (
        <Box
            component={"img"}
            {...props}
            sx={(theme) => ({
                maxWidth: "100%",
                maxHeight: 300,
                borderRadius: theme.radius.sm,
                filter: theme.colorScheme == "dark" ? "invert(0.930)" : "none",
            })}
            loading="lazy"
        />
    );
};

const MyMarkdown = (props) => {
    let options = {
        overrides: {
            InlineMath: {
                component: InlineMath,
            },
            BlockMath: {
                component: BlockMath,
            },
            img: {
                component: MyImg,
            },
            a: {
                component: Link,
                props: {
                    rel: "noopener",
                    target: "_blank",
                    ...props,
                },
            },
            h1: {
                component: Text,
                props: {
                    component: "h1",
                    m: 0,
                    ...props,
                },
            },
            h2: {
                component: Text,
                props: {
                    component: "h2",
                    m: 0,
                    ...props,
                },
            },
            h3: {
                component: Text,
                props: {
                    component: "h3",
                    m: 0,
                    ...props,
                },
            },
            h4: {
                component: Text,
                props: {
                    component: "h4",
                    m: 0,
                    ...props,
                },
            },
            h5: {
                component: Text,
                props: {
                    component: "h5",
                    m: 0,
                    ...props,
                },
            },
            h6: {
                component: Text,
                props: {
                    component: "h6",
                    m: 0,
                    ...props,
                },
            },
            p: {
                component: Text,
                props: {
                    component: "p",
                    m: 0,
                    fz: "lg",
                    ...props,
                },
            },
            script: {
                component: Text,
                props: {
                    c: "dimmed",
                    component: "p",
                },
            },
            iframe: {
                component: Text,
                props: {
                    fz: "xs",
                    component: "p",
                },
            },
            pre: {
                component: Text,
            },
        },
        wrapper: BoxWrapper,
        forceWrapper: true,
        disableParsingRawHTML: true,
        forceBlock: true,
    };
    return <Markdown {...props} options={options} />;
};

export default MyMarkdown;
